export enum ID_APPLICANT {
  PADRE = '1',
  MADRE = '2',
  SOGGETTO = '3',
  ALTRO = '4',
  MADRE_PADRE = '5',
  AUTORITA_GIURISDIZIONALE = '6',
}
